import { getSvgIcon, Icon } from '@helpers/icons';
import { imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { withMotionMax } from '@hoc/withMotionMax';
import { useHoverIntent } from '@hooks/useHoverIntent';
import useMedia from '@hooks/useMedia';
import { useOutsideClick } from '@hooks/useOutsideClick';
import SvgLogo from '@img/logo.svg';
import SearchBar from '@stories/Widgets/SearchBar/SearchBar';
import * as React from 'react';
import S, { DesktopBreakpoint } from './Header.styles';
const Header = (props) => {
    const [activeId, setActiveId] = React.useState('');
    const [menuOpen, setMenuOpen] = React.useState(false);
    const isMobile = useMedia([until(DesktopBreakpoint)], [true], false);
    const handleActivateChange = (id) => {
        if (id) {
            setActiveId(id);
        }
        else {
            setActiveId('');
        }
    };
    const containerRef = useOutsideClick(() => {
        handleActivateChange('');
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(S.Container, { ref: containerRef, onMouseLeave: () => {
                if (isMobile)
                    return;
                handleActivateChange('');
            } },
            React.createElement(S.Inner, null,
                React.createElement(S.Logo, { href: "/", "aria-label": props.translations?.['global.navigation.home'] },
                    React.createElement(SvgLogo, null)),
                React.createElement(S.Nav, { id: "main-navigation", "aria-expanded": menuOpen || !isMobile, onMouseLeave: () => {
                        if (isMobile)
                            return;
                        handleActivateChange('');
                    } },
                    React.createElement("ul", { role: "menubar" }, props.links?.map((link, i) => (React.createElement(NavLink, { key: link.id, activeId: activeId, isFirst: i === 0, link: link, mobile: isMobile, onActivateChange: handleActivateChange, translations: props.translations })))),
                    React.createElement("ul", null,
                        React.createElement(S.NavLink, { role: "none" },
                            React.createElement(S.NavLinkAnchor, { as: "button", role: "menuitem", "data-icon-only": true, onMouseEnter: () => {
                                    if (isMobile)
                                        return;
                                    handleActivateChange('search-dropdown');
                                }, onFocus: () => handleActivateChange('search-dropdown'), "aria-haspopup": "menu", "aria-expanded": activeId === 'search-dropdown', "aria-controls": "search-dropdown", "aria-label": activeId === 'search-dropdown'
                                    ? props.translations?.['global.search.close']
                                    : props.translations?.['global.search.open'], "data-search": true },
                                getSvgIcon(Icon.Search),
                                activeId === 'search-dropdown' && (React.createElement(S.Underline, { layoutId: "desktop-navigation-underline", initial: false, transition: {
                                        type: 'spring',
                                        stiffness: 100,
                                        damping: 20,
                                    } }))),
                            React.createElement(S.DropdownLinks, { id: "search-dropdown", role: "menu", "aria-current": activeId === 'search-dropdown' ? 'true' : 'false', "data-search": true, as: "div" },
                                React.createElement(SearchBar, { idPrefix: "header", isComponent: true, label: props.searchBar.label, submitUrl: props.searchBar.submitUrl, textButton: true, translations: props.translations, searchPlaceholder: props.searchBar.searchPlaceholder }))),
                        React.createElement(S.NavLink, { role: "none" },
                            React.createElement(S.NavLinkAnchor, { as: "button", role: "menuitem", "data-icon-only": true, onMouseEnter: () => {
                                    if (isMobile)
                                        return;
                                    handleActivateChange('account-dropdown');
                                }, onFocus: () => handleActivateChange('account-dropdown'), "aria-haspopup": "menu", "aria-expanded": activeId === 'account-dropdown', "aria-controls": "account-dropdown" },
                                props.accountDropdown.image ? (React.createElement("img", { src: imageUrl(props.accountDropdown.image, { width: 48, rmode: 'pad' }), alt: props.accountDropdown.image?.altText })) : props.accountDropdown.initials ? (React.createElement(S.NavInitials, null, props.accountDropdown.initials)) : (getSvgIcon(Icon.User)),
                                React.createElement(S.NavLinkTextContainer, null,
                                    React.createElement(S.NavLinkText, null, props.accountDropdown.text)),
                                getSvgIcon(Icon.ChevronDown),
                                activeId === 'account-dropdown' && (React.createElement(S.Underline, { layoutId: "desktop-navigation-underline", initial: false, transition: {
                                        type: 'spring',
                                        stiffness: 100,
                                        damping: 20,
                                    } }))),
                            React.createElement(S.DropdownLinks, { id: "account-dropdown", role: "menu", "aria-current": activeId === 'account-dropdown' ? 'true' : 'false', "data-account": true },
                                React.createElement(S.NavLink, { role: "none", "data-back": true },
                                    React.createElement(S.NavLinkAnchor, { role: "menuitem", as: "button", onClick: (e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleActivateChange('');
                                        } },
                                        getSvgIcon(Icon.ChevronDown),
                                        React.createElement(S.NavLinkTextContainer, null,
                                            React.createElement(S.NavLinkText, null, props.accountDropdown.links[0].text)),
                                        props.accountDropdown.image ? (React.createElement("img", { src: imageUrl(props.accountDropdown.image, { width: 48, rmode: 'pad' }), alt: props.accountDropdown.image?.altText })) : props.accountDropdown.initials ? (React.createElement(S.NavInitials, null, props.accountDropdown.initials)) : (getSvgIcon(Icon.User)))),
                                props.accountDropdown.links.map((item) => (React.createElement("li", { key: item.id, role: "none" },
                                    React.createElement(S.NavLinkAnchor, { role: "menuitem", href: item.url, target: item.target, tabIndex: activeId === 'account-dropdown' ? 0 : -1 },
                                        item.icon ? (getSvgIcon(item.icon)) : props.accountDropdown.image ? (React.createElement("img", { src: imageUrl(props.accountDropdown.image, { width: 48, height: 48 }), alt: props.accountDropdown.image?.altText })) : props.accountDropdown.initials ? (React.createElement(S.NavInitials, null, props.accountDropdown.initials)) : null,
                                        React.createElement(S.NavLinkTextContainer, null,
                                            React.createElement(S.NavLinkText, null, item.text)),
                                        getSvgIcon(Icon.ChevronDown))))))))),
                React.createElement(S.MenuButton, { as: "button", type: "button", onClick: () => {
                        setMenuOpen(false);
                        if (activeId === 'search-dropdown') {
                            handleActivateChange('');
                        }
                        else {
                            handleActivateChange('search-dropdown');
                        }
                    }, "aria-haspopup": "menu", "aria-expanded": activeId === 'search-dropdown', "aria-controls": "search-dropdown", "aria-label": activeId === 'search-dropdown'
                        ? props.translations?.['global.search.close']
                        : props.translations?.['global.search.open'] },
                    getSvgIcon(Icon.Search),
                    getSvgIcon(Icon.Close)),
                React.createElement(S.MenuButton, { as: "button", type: "button", onClick: () => {
                        setMenuOpen((prev) => !prev);
                        handleActivateChange(menuOpen ? '' : 'menu-dropdown');
                    }, "aria-label": menuOpen
                        ? props.translations?.['global.navigation.close']
                        : props.translations?.['global.navigation.open'], "aria-haspopup": "menu", "aria-expanded": menuOpen, "aria-controls": "main-navigation" },
                    getSvgIcon(Icon.Menu),
                    getSvgIcon(Icon.Close)))),
        React.createElement(S.Background, { "data-active": activeId || (menuOpen && isMobile) ? 'true' : 'false' })));
};
const NavLink = (props) => {
    const hasChildren = props.link.children && props.link.children.length > 0;
    const isActive = props.link.id === props.activeId;
    const itemsRef = React.useRef([]);
    const { ref: anchorRef } = useHoverIntent({
        onHover() {
            // Explicit width check due to the fact props are not updated within the hover intent hook
            if (window.innerWidth < Device.TabletLarge) {
                return;
            }
            props.onActivateChange(props.link.id);
        },
    });
    return (React.createElement(S.NavLink, { role: "none" },
        React.createElement(S.NavLinkAnchor, { ...(props.link.url ? { as: 'a', href: props.link.url } : { as: 'span' }), ref: anchorRef, id: `navlink-${props.link.id}`, role: "menuitem", "data-top": true, ...(hasChildren
                ? {
                    'aria-haspopup': 'menu',
                    'aria-expanded': isActive,
                    'aria-controls': `dropdown-${props.link.id}`,
                    onClick: (e) => {
                        if (props.mobile) {
                            e.preventDefault();
                            e.stopPropagation();
                            props.onActivateChange(props.link.id);
                        }
                    },
                }
                : {}), tabIndex: isActive || !props.activeId ? 0 : -1 },
            renderLink(props.link),
            isActive && (React.createElement(S.Underline, { layoutId: "desktop-navigation-underline", initial: false, transition: {
                    type: 'spring',
                    stiffness: 100,
                    damping: 20,
                } }))),
        hasChildren ? (React.createElement(S.DropdownLinks, { id: `dropdown-${props.link.id}`, role: "menu", "aria-current": isActive ? 'true' : 'false', "data-first": props.isFirst },
            React.createElement(S.NavLink, { role: "none", "data-back": true },
                React.createElement(S.NavLinkAnchor, { role: "menuitem", as: "button", onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        props.onActivateChange('');
                    } },
                    getSvgIcon(Icon.ChevronDown),
                    React.createElement(S.NavLinkTextContainer, null,
                        React.createElement(S.NavLinkText, null, props.link.text)),
                    props.link.icon ? getSvgIcon(props.link.icon) : null)),
            props.link.children?.map((item) => (React.createElement("li", { key: item.id, role: "none" },
                React.createElement(S.NavLinkAnchor, { ref: (el) => {
                        if (el) {
                            itemsRef.current.push(el);
                        }
                    }, role: "menuitem", href: item.url, target: item.target, tabIndex: isActive ? 0 : -1 }, renderLink(item))))))) : null));
    function renderLink(item) {
        return (React.createElement(React.Fragment, null,
            item.image ? (React.createElement("img", { src: imageUrl(item.image, { width: 48, rmode: 'pad' }), alt: props.link.text })) : item.icon ? (getSvgIcon(item.icon)) : null,
            React.createElement(S.NavLinkTextContainer, null,
                React.createElement(S.NavLinkText, null, item.text),
                item.description && React.createElement(S.NavLinkDescription, null, item.description))));
    }
};
export default withMotionMax(Header);
